import React, { useState, useEffect } from 'react';
import { getIconComponent } from '../../../../shared/Icon'; // Asegúrate de la ruta correcta
import './filterreditemlist.css';

/**
 * FilteredItemList: Componente que filtra y muestra una lista de ítems basados en un tipo especificado.
 * Muestra los ítems disponibles y permite expandir o colapsar la lista, además de mostrar más ítems si
 * el usuario lo desea.
 *
 * @param {object} props - Propiedades del componente.
 * @param {string} props.type - Tipo de ítems (por ejemplo, 'Servicios adicionales', 'Amenidades').
 * @param {array} props.items - Lista de ítems a mostrar.
 * @param {number} [props.columns=3] - Número de columnas en la cuadrícula de ítems.
 * @param {number} [props.initialVisibleCount=6] - Número inicial de ítems visibles.
 * @returns {ReactElement} - Componente de lista filtrada.
 */
export const FilteredItemList = ({ type, items, columns = 3, initialVisibleCount = 6 }) => {
  const [visibleCount, setVisibleCount] = useState(initialVisibleCount);
  const [showAll, setShowAll] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const [dynamicColumns, setDynamicColumns] = useState(columns);

  // const sortedItems = type === "amenidades"
  // ? [...items].sort((a, b) => a.name.localeCompare(b.name))
  // : items;
  const sortedItems = [...items].sort((a, b) => a.name.localeCompare(b.name));


  // Detectar el tamaño de la ventana y ajustar las columnas
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 480) {
        setDynamicColumns(2); // En pantallas pequeñas (480px o menos), 2 columnas
      } else if (window.innerWidth <= 764) {
        setDynamicColumns(3); // En pantallas entre 481px y 764px, 3 columnas
      } else {
        setDynamicColumns(columns); // En pantallas grandes, usar el valor original de columnas
      }
    };


    // if (type === "Servicios adicionales") {
    //   const handleResize = () => {
    //     if (window.innerWidth <= 480) {
    //       setDynamicColumns(2); // En pantallas pequeñas (480px o menos), 2 columnas
    //     } else if (window.innerWidth <= 764) {
    //       setDynamicColumns(3); // En pantallas entre 481px y 764px, 3 columnas
    //     } else {
    //       setDynamicColumns(columns); // En pantallas grandes, usar el valor original de columnas
    //     }
    //   };

    // Ejecutar al montar el componente
    handleResize();

    // Agregar el event listener para el cambio de tamaño de la ventana
    window.addEventListener("resize", handleResize);

    // Limpiar el listener cuando el componente se desmonte
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [columns]); // Reejecutar el hook cuando cambie el valor de columns

  const gridStyle = {
    gridTemplateColumns: `repeat(${dynamicColumns}, 1fr)`, // Usamos dynamicColumns
  };

  const containerClass = type === "Servicios adicionales" ? "type-list aditional-service" : "type-list";

  // Si no hay items disponibles, muestra un mensaje indicándolo
  if (!items || items.length === 0) {
    return <p>No hay {type} disponibles.</p>;
  }

  // Maneja la visibilidad de los items (mostrar más/menos)
  const handleToggleVisibility = () => {
    setShowAll(!showAll);
    setVisibleCount(showAll ? initialVisibleCount : items.length);
  };

  // Maneja la expansión/colapso de la lista
  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={containerClass}>
      {/* Botón para expandir/colapsar la lista */}
      <h2 onClick={type === "Servicios adicionales" ? toggleExpansion : null}>
        {type.charAt(0).toUpperCase() + type.slice(1)}
      </h2>

      {isExpanded && (
        <>
          <ul style={gridStyle}>
            {/* Renderiza los ítems visibles */}
            {sortedItems.slice(0, visibleCount).map((item) => {
              const iconName = item.icono; // Nombre del ícono
              const iconColor = item.colorIcono; // Color del ícono

              return (
                <li key={item.id} className={`${type}-item`}>
                  {/* Se pasa el icono a 'getIconComponent' */}
                  {getIconComponent({ icono: iconName, iconColor })}

                  {/* Renderiza el nombre del ítem */}
                  <div className="item-text capitalize-first-letter">{item.name}</div>
                </li>
              );
            })}
          </ul>

          {/* Botón para mostrar más ítems si el estado showAll es verdadero */}
          {items.length > initialVisibleCount && (
            <button onClick={handleToggleVisibility} className="show-more-button">
              {showAll ? 'Ver menos' : 'Ver más'}
            </button>
          )}
        </>
      )}
    </div>
  );
};
